<div class="backDrop" *ngIf="showSubject.asObservable() | async">
	<div class="modal-dialog modal-lg update-modal">
		<div class="modal-content">
			<!-- Modal Header -->
			<div class="modal-header">
				<h4 class="modal-title">{{ title }}</h4>
			</div>
			<div class="modal-body">
				<!-- Modal body -->

				<dx-tab-panel #tabPanel [height]="550" [scrollByContent]="true" [dataSource]="listOfTabs" [(selectedIndex)]="selectedTab" [loop]="false">
					<div *dxTemplate="let title of 'title'">
						<span>{{ title.TabName }}</span>
					</div>
					<div *dxTemplate="let item of 'item'">

						<div *ngIf="item.ID == 1">
							<br>
							<dx-select-box [items]="linkTemplate$ | async" displayExpr="description" valueExpr="id" (onValueChanged)="onValueChanged($event)"></dx-select-box>

							<div *ngIf="selectedLinkTemplateId.asObservable() | async" class="flex-container">

								<div>
									<dx-data-grid [dataSource]="linkSettings" [height]="420" [showBorders]="true" (onRowUpdated)="updateSettingTemplateField($event)" [disabled]="settingTemplateDataGridDisabled | async">
										<dxo-sorting mode="none">
											<!-- or "multiple" | "none" -->
										</dxo-sorting>
										<dxo-editing mode="row" [allowUpdating]="true">
										</dxo-editing>
										<dxo-selection mode="none"></dxo-selection>
										<dxo-row-dragging [onAdd]="onAdd" [allowReordering]="true" [onReorder]="onReorder"></dxo-row-dragging>
										<dxo-scrolling mode="virtual"></dxo-scrolling>

										<dxi-column dataField="sortingIndex" dataType="number" [sortIndex]="0" sortOrder="asc" [width]="100" [allowEditing]="false"></dxi-column>
										<dxi-column dataField="displayName" dataType="string" [width]="300" [allowEditing]="false">
										</dxi-column>
										<dxi-column dataField="groupName" dataType="string">
											<dxo-lookup [dataSource]="linkGroupSettings" valueExpr="name" displayExpr="name">
											</dxo-lookup>
										</dxi-column>
										<dxi-column dataField="accessLevel" [width]="100" dataType="string" cellTemplate="cellTemplate">
											<dxo-lookup [dataSource]="listOfAccessLevels" valueExpr="id" displayExpr="name">
											</dxo-lookup>
										</dxi-column>
										<!-- <dxi-column dataField="groupName" [width]="100" dataType="string">
                                            <dxo-lookup
                                                [dataSource]="linkGroupSettings"
                                                valueExpr="id"
                                                displayExpr="Name"
                                            >
                                            </dxo-lookup>
                                        </dxi-column> -->
										<div *dxTemplate="let data of 'cellTemplate'">
											{{accessLevel[data.value]}}
										</div>
									</dx-data-grid>
								</div>
							</div>
						</div>

						<div *ngIf="item.ID == 2">
							<div>

								<div class="flex-container">
									<div class="flex-item">
										<fieldset>
											<legend>Create new group</legend>
											<div class="custom-form" [formGroup]="contactForm">
												<label class="form-label">Name</label>
												<dx-text-box [formControlName]="'name'" placeholder="Enter a group name">
												</dx-text-box>
												<br>
												<dx-button type="default" [disabled]="!contactForm.valid" (onClick)="createNewGroup()" text="Create">
												</dx-button>
											</div>
										</fieldset>
									</div>
									<div class="flex-item">
										<fieldset>
											<legend>Manage groups</legend>
											<dx-data-grid #linksettinggroupinggrid [dataSource]="linkGroupSettings" [height]="420" [showBorders]="true" [disabled]="groupManagementDataGridDisabled | async">
												<dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false">
												</dxo-editing>
												<!-- <dxo-editing
                                        mode="form"
                                        [allowUpdating]="true"
                                        [allowAdding]="true"
                                        [allowDeleting]="true"
                                      >
                                      </dxo-editing> -->
												<dxo-sorting mode="none">
													<!-- or "multiple" | "none" -->
												</dxo-sorting>
												<dxo-selection mode="none"></dxo-selection>
												<dxo-row-dragging [onAdd]="onAdd" [allowReordering]="true" [onReorder]="onReorderGroupSettings"></dxo-row-dragging>
												<dxo-scrolling mode="virtual"></dxo-scrolling>

												<dxi-column dataField="index" dataType="number" [sortIndex]="0" sortOrder="asc" [width]="70"></dxi-column>
												<dxi-column dataField="name" dataType="string" [width]="300" [setCellValue]="setCellValueEdit">
												</dxi-column>
												<dxi-column [width]="30" [allowFiltering]="false" [allowSorting]="false" cellTemplate="cellTemplate"></dxi-column>
												<div *dxTemplate="let data of 'cellTemplate'">
													<i class="far fa-fw fa-trash-alt btn-delete" hint="Delete" (click)="attemptToDelete(data)"></i>
												</div>

											</dx-data-grid>
										</fieldset>
									</div>

								</div>
							</div>
						</div>
						<div *ngIf="item.ID == 3">
							<app-link-information-setting-blacklist></app-link-information-setting-blacklist>
						</div>
					</div>
				</dx-tab-panel>

			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<ng-container *ngIf="selectedTab == 0">
					<button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="save()">
                        Save
                    </button>
				</ng-container>
				<ng-container *ngIf="selectedTab == 1">
					<button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="saveGroupSettings()">
                        Save
                    </button>
				</ng-container>
				<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cancel()">
                    Cancel
                </button>
			</div>
		</div>
	</div>
</div>
